module.exports = __webpack_public_path__ + "static/media/29FUNOV16.a8bd500a.jpg";